import React, { useState, useEffect } from "react";
import { Card, Button, Table, Form, Row, Col, Alert, Modal, Spinner, Image } from "react-bootstrap";
import { PlusCircle, PencilSquare, Trash, CurrencyDollar, BoxArrowInRight, BoxArrowLeft } from "react-bootstrap-icons";
import Cookies from "js-cookie";
import api from "../../../services/api";
import { API_BASE_URL } from "../../../config";

function ControleEstoqueMaster() {
  const [produtos, setProdutos] = useState([]);
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showVendasModal, setShowVendasModal] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [form, setForm] = useState({
    nome: "",
    preco: "",
    estoque: "",
    imagem: null,
  });
  const [imagemPreview, setImagemPreview] = useState(null);

  const usuario = JSON.parse(Cookies.get("usuario") || "{}");
  const idClienteMaster = usuario.id;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setErro("");
    try {
      const [produtosRes, vendasRes] = await Promise.all([
        api.get(`/Produtos?idClienteMaster=${idClienteMaster}`),
        api.get(`/Produtos/vendas?idClienteMaster=${idClienteMaster}`),
      ]);
      setProdutos(produtosRes.data);
      setVendas(vendasRes.data);
    } catch (err) {
      setErro("Erro ao carregar dados: " + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };
  
  const cardStyle = {
    backgroundColor: '#3c4049',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    padding: '25px',
    width: '95%',         // ocupa quase toda a largura
    maxWidth: '1200px',   // limite em telas grandes
    margin: '0 auto',     // centraliza
  };

  const handleShowModal = (produto = null) => {
    setProdutoSelecionado(produto);
    if (produto) {
      setForm({
        nome: produto.nome,
        preco: produto.preco,
        estoque: produto.estoque,
        imagem: null,
      });
      setImagemPreview(produto.imagemUrl ? `${API_BASE_URL}${produto.imagemUrl}` : null);
    } else {
      setForm({ nome: "", preco: "", estoque: "", imagem: null });
      setImagemPreview(null);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setProdutoSelecionado(null);
    setImagemPreview(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setForm({ ...form, imagem: file });
    if (file) {
      setImagemPreview(URL.createObjectURL(file));
    } else {
      setImagemPreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro("");

    const formData = new FormData();
    formData.append("Nome", form.nome);
    formData.append("Preco", form.preco);
    formData.append("Estoque", form.estoque);
    formData.append("ClienteMasterId", idClienteMaster);
    if (form.imagem) {
      formData.append("Imagem", form.imagem);
    }

    try {
      if (produtoSelecionado) {
        // Edição
        await api.put(`/Produtos/${produtoSelecionado.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        // Criação
        await api.post("/Produtos", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
      handleCloseModal();
      fetchData();
    } catch (err) {
      setErro("Erro ao salvar produto: " + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (await window.globalConfirm("Tem certeza que deseja excluir este produto?")) {
      setLoading(true);
      setErro("");
      try {
        await api.delete(`/Produtos/${id}`);
        fetchData();
      } catch (err) {
        setErro("Erro ao excluir produto: " + (err.response?.data?.message || err.message));
      } finally {
        setLoading(false);
      }
    }
  };

  const formatarData = (data) => {
    return new Date(data).toLocaleString("pt-BR");
  };

  if (loading) {
    return <div className="text-center"><Spinner animation="border" /></div>;
  }

  return (
    <Card className="shadow-lg" style={cardStyle}>
      <Card.Title className="d-flex justify-content-between align-items-center">
        Controle Total de Estoque
        <div>
          <Button variant="info" className="me-2" onClick={() => setShowVendasModal(true)}>
            <CurrencyDollar className="me-1" /> Tabela de Vendas
          </Button>
          <Button variant="primary" onClick={() => handleShowModal()}>
            <PlusCircle className="me-1" /> Adicionar Produto
          </Button>
        </div>
      </Card.Title>
      <hr />

      {erro && <Alert variant="danger">{erro}</Alert>}

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Imagem</th>
            <th>Nome</th>
            <th>Preço</th>
            <th>Estoque</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {produtos.map((produto) => (
            <tr key={produto.id}>
              <td>{produto.id}</td>
              <td>
                {produto.imagemUrl ? (
                  <Image
                    src={`${API_BASE_URL}${produto.imagemUrl}`}
                    rounded
                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                  />
                ) : (
                  "Sem Imagem"
                )}
              </td>
              <td>{produto.nome}</td>
              <td>R$ {produto.preco.toFixed(2).replace(".", ",")}</td>
              <td>{produto.estoque}</td>
              <td>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2"
                  onClick={() => handleShowModal(produto)}
                >
                  <PencilSquare />
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(produto.id)}
                >
                  <Trash />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal de Adição/Edição de Produto */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{produtoSelecionado ? "Editar Produto" : "Adicionar Novo Produto"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nome</Form.Label>
              <Form.Control
                type="text"
                name="nome"
                value={form.nome}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Preço</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="preco"
                    value={form.preco}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Estoque</Form.Label>
                  <Form.Control
                    type="number"
                    name="estoque"
                    value={form.estoque}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Imagem (Campo igual de fotos do funcionário)</Form.Label>
              <Form.Control
                type="file"
                name="imagem"
                onChange={handleImageChange}
                accept="image/*"
              />
              {imagemPreview && (
                <div className="mt-2 text-center">
                  <Image src={imagemPreview} thumbnail style={{ maxWidth: "150px", maxHeight: "150px" }} />
                </div>
              )}
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : "Salvar Produto"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal de Tabela de Vendas */}
      <Modal show={showVendasModal} onHide={() => setShowVendasModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Tabela de Vendas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Data</th>
                <th>Produto</th>
                <th>Cliente</th>
                <th>Quantidade</th>
                <th>Preço Unitário</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {vendas.length > 0 ? (
                vendas.map((venda) => (
                  <tr key={venda.id}>
                    <td>{formatarData(venda.dataVenda)}</td>
                    <td>{venda.produto?.nome || "Produto Excluído"}</td>
                    <td>{venda.cliente?.nome || "Cliente Excluído"}</td>
                    <td>{venda.quantidade}</td>
                    <td>R$ {venda.precoUnitario.toFixed(2).replace(".", ",")}</td>
                    <td>R$ {(venda.quantidade * venda.precoUnitario).toFixed(2).replace(".", ",")}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">Nenhuma venda registrada.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVendasModal(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
}

export default ControleEstoqueMaster;
